import { render, staticRenderFns } from "./demo2.vue?vue&type=template&id=06773a9c&scoped=true&"
import script from "./demo2.vue?vue&type=script&lang=js&"
export * from "./demo2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06773a9c",
  null
  
)

export default component.exports